<template>
  <div class="elst-downloading" v-show="visible">
    <div class="elst-downloading__container">
      <a
        href="javascript:"
        class="elst-downloading__close"
        v-if="showClose"
        @click="cancelHandler"
      >
        <i class="icon icon-close"></i>
      </a>
      <p class="elst-downloading__title">{{ downTitle }}</p>
      <div class="elst-downloading__body">
        <div class="elst-downloading__progress">
          <div
            class="elst-downloading__progress-bar"
            :style="{ width: progress + '%' }"
          ></div>
        </div>
      </div>
    </div>
    <div class="elst-downloading__mask"></div>
  </div>
</template>

<script>
import i18n from '@/locales'

export default {
  name: 'DownLoading',
  props: {
    title: {
      type: String,
      default: '',
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: false,
    },
    // 取消下载事件
    cancelHandler: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      progress: 0,
    }
  },
  computed: {
    downTitle(){
      return this.title || i18n.t('hint_common_wait_loading')
    }},
  methods: {},
}
</script>

<style lang="scss" scoped>
.elst-downloading {
  &__close {
    position: absolute;
    z-index: 11;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;

    .icon-close {
      display: block;
      width: 12px;
      height: 12px;
      background-image: url(~@/assets/images/icon-close.png);
    }
  }

  &__container {
    position: absolute;
    z-index: 10001;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    min-height: 85px;
    background-color: #fff;
    -webkit-box-shadow: 0 2px 3px 3px rgba(0, 0, 0, 0.05);
    box-shadow: 0 2px 3px 3px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
  }

  &__mask {
    position: absolute;
    z-index: 10000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.5;
  }

  &__title {
    padding: 24px 10px 0;
    text-align: center;
    font-size: 14px;
  }

  &__body {
    padding: 10px;
  }

  &__progress {
    height: 8px;
    overflow: hidden;
    background-color: #f5f5f5;
    border-radius: 4px;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  &__progress-bar {
    width: 0;
    height: 100%;
    border-radius: 4px;
    background-color: #4da8ff;
  }
}
</style>
